import React, {useEffect, useReducer, useMemo, useState} from 'react'
import {useSubheader} from '../../../../_metronic/layout'
import {NotificationOrderList} from './NotificationOrderList'
import {NotificationBody} from './NotificationBody'
import {getOrderForm} from '../../Wizard/_redux/wizardCrud'
import {OrderSheet} from '../../OrderSheet/page/OrderSheet'
import {useLocation} from 'react-router-dom'
import k1utils from '../../../../util/k1utils'
// import { result } from "lodash";

const initialState = {
  notification: {},
  orderForm: {optionList: []},
  order: {order_value: []},
  orderStatus: 5010,
  store: {},
  calStep: undefined,
  workTypeValue: 'ORDER',
}

export const SET_NOTIFICATION = 'SET_NOTIFICATION'
export const SET_STATUS = 'SET_STATUS'
const reducer = (state, action) => {
  switch (action.type) {
    case SET_NOTIFICATION:
      return {
        ...state,
        notification: action.notification,
        orderForm: action.orderForm,
        order: action.order,
        orderStatus: action.orderStatus,
        store: action.store,
        calStep: action.calStep,
        workTypeValue: action.workTypeValue,
        paymentCard: action.paymentCard,
      }
    case SET_STATUS:
      const copyOrder = {...state.order}
      copyOrder.order_status = action.status
      return {
        ...state,
        order: copyOrder,
      }
    default:
      throw new Error()
  }
}

const notificationStatus = (status) => status === 5020 || status === 5090 || status === 5100

const orderSheetStatus = (status) =>
  status === 5030 ||
  status === 5040 ||
  status === 5050 ||
  status === 5060 ||
  status === 5065 ||
  status === 5070 ||
  status === 5080

export const Notification = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const {
    notification,
    orderForm,
    order,
    orderStatus,
    store,
    calStep,
    workTypeValue = 'ORDER',
    paymentCard,
  } = useMemo(() => state, [state])
  const [err, setErr] = useState(null)
  const location = useLocation()
  const order_key = location?.pathname.split('/')[2]
  const update_flag = location?.pathname.split('/')[3] || 'na'
  // const suhbeader = useSubheader()
  // suhbeader.setTitle(store.name)
  // console.log("Notification")
  useEffect(() => {
    getOrderForm(order_key)
      .then((res) => {
        const result = res.data.data
        dispatch({
          type: SET_NOTIFICATION,
          notification: result.ordertype[0],
          orderForm: result.ordertype[1],
          order: result.order,
          orderStatus: result.order.order_status,
          store: result.store,
          calStep: result.tstoreConfs
            ? result.tstoreConfs.find((conf) => conf.key === 'CALCULATION_STEP')?.value
            : undefined,
          workTypeValue: result.tstoreConfs
            ? result.tstoreConfs.find((conf) => conf.key === 'WORK_TYPE')?.value
            : 'ORDER',
          paymentCard: result.tstoreConfs
            ? result.tstoreConfs.find((conf) => conf.key === 'PAY_CARD')?.value
            : 'false',
        })
        const backgroundImageUrl = k1utils.toBigFileUrl(result.store.t_fileidx)
        document.getElementById('root').style.backgroundImage = `url(${backgroundImageUrl})`
      })
      .catch((err) => {
        console.error(err)
        // setErr(JSON.stringify(err?.response?.data))
        setErr("주문서 작성 시간이 초과하였습니다. 처음부터 다시 시작해주세요.")
      })
  }, [order_key, update_flag])

  const closeWindow = () => {
                        /* 카카오톡 화면 닫기 */
                        var _ua = window.navigator.userAgent || window.navigator.vendor || window.opera
                        if (_ua.toLocaleLowerCase().indexOf('kakaotalk')) {
                            window.location.href = /iPad|iPhone|iPod/.test(_ua)
                                ? 'kakaoweb://closeBrowser'
                                : 'kakaotalk://inappbrowser/close'
                        }
  }

  return (
    <div className='card card-custom'>
      {/* begin::Notification */}
      {/* end::Notification */}

      {/* begin::Order Sheet */}
      {notificationStatus(orderStatus) && (
        <div className='card-body d-flex flex-column p-3'>
          <NotificationBody data={notification} store={store} />
          <NotificationOrderList data={orderForm} order_key={order_key} />
        </div>
      )}
      {orderSheetStatus(orderStatus) && (
        <OrderSheet
          data={order}
          store={store}
          dispatch={dispatch}
          calStep={calStep}
          workTypeValue={workTypeValue}
          paymentCard={paymentCard}
        />
      )}
      {err !== null && (
        <div className='card-body d-flex flex-column p-3'>
          <div>
            {err}
          </div>
          <div className='btn btn-outline-primary' onClick={closeWindow}>처음부터 다시 시작</div>
        </div>
      )}
      {/* end::Order Sheet */}
    </div>
  )
}
